export class PatternInterface {
    readonly type: string;
}